import { useParams } from "react-router-dom";
import AppLayout from "../../components/AppLayout";
import { ErrorNote, Loading } from "../../components/Feedback";
import { useApi } from "../../useApi";
import { ProjectLog } from "./LogView";

// /projects/:projectId/log: every member of the project reads its log (task 2026-10-20
// "each project has a log"); the backend answers 404 to anybody else.
export default function ProjectLogPage() {
  const { projectId } = useParams();
  const project = useApi(`/projects/${projectId}`);
  const p = project.data;
  return (
    <AppLayout title={p ? `Log of ${p.name}` : "Log"}
               crumbs={[{ label: "Projects", to: "/projects" }, { label: p ? p.name : "…", to: `/projects/${projectId}` }, { label: "Log" }]}>
      <ErrorNote error={project.error} />
      {project.loading && <Loading />}
      {p && <ProjectLog project={p} />}
    </AppLayout>
  );
}
